<div class="labo-row-compact" *ngIf="mode == 'compact'">
    <div style="position:relative;">
        <div style="float:right;">{{ date }}</div>
    </div>
    <div style="clear:both;">{{ record.value }}</div>
</div>
<div class="labo-row-full" *ngIf="mode == 'full'">
    <div class="flex-container labo-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="80px">
            <div>
                <div class="flex-container labo-row-icons" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                    <fa-icon (click)="openAccess()" [icon]="['fas', 'user-lock']" [styles]="{'color': '#df8a1d'}" size="lg"></fa-icon>
                    <fa-icon (click)="expanded = !expanded" *ngIf="!expanded" [icon]="['fas', 'chevron-right']" [styles]="{'color': 'red'}" size="lg"></fa-icon>
                    <fa-icon (click)="expanded = !expanded" *ngIf="expanded"[icon]="['fas', 'chevron-down']" [styles]="{'color': 'red'}" size="lg"></fa-icon>
                </div>
            </div>
            <div class="row-date">{{ date }}</div>
        </div>
        <div fxFlex="grow">
            <div class="labo-content">
                <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                    <div fxFlex="grow" style="text-align: left;"> {{ record.getProperty('RefLabo') }} - {{ record.getProperty('NomLabo')}}</div>
                    <div fxFlex="grow" style="text-align: right;">{{ record.getProperty('MedecinPrescripteur') }} - {{ record.getProperty('Partiel/Complet')}}</div>
                </div>
                <div *ngIf="!expanded">
                    <div *ngFor="let anomaly of record.anomalies" class="flex-container labo-anomaly" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                        <div fxFlex="grow">{{ anomaly.name }}</div>
                        <div fxFlex="250px">{{ anomaly.result }}</div>
                        <div fxFlex="150px">{{ anomaly.unit }}</div>
                        <div fxFlex="150px">{{ anomaly.norm }}</div>
                    </div>
                </div>
                <div *ngIf="expanded">
                    <div *ngFor="let result of record.results" class="flex-container" [ngClass]="{'labo-anomaly' : result.anomaly}" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                        <div fxFlex="grow">{{ result.name }}</div>
                        <div fxFlex="250px">{{ result.result }}</div>
                        <div fxFlex="150px">{{ result.unit }}</div>
                        <div fxFlex="150px">{{ result.norm }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>